<template>
  <b-card header="Armature Error Summary" style="margin-bottom: 0;">
    <b-card-body>
      <b-row>
        <b-col lg="4">
          <highcharts :options="pieChartOpts"></highcharts>
        </b-col>
        <b-col lg="8">
          <b-table
            hover
            small
            responsive="sm"
            stacked="md"
            :fields="tableFields"
            :items="tableData"
            :per-page="perPage"
            :current-page="currentPage"
            class="mb-0 table-outline"
            id="armErrorTable"
            head-variant="light">
          </b-table>
          <b-row>
            <b-col md="6" class="my-1">
              <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0" />
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import { armColors } from '../../helpers/colorDecoder';

const pieChartColorPicker = (err) => {
  let outputColor = null;
  switch (err) {
    case 'Healthy':
      outputColor = armColors.healthy.color;
      break;
    case 'Azimuth Reed Error':
      outputColor = armColors.azimuthError.color;
      break;
    case 'Elevation Reed Error':
      outputColor = armColors.elevationError.color;
      break;
    case 'Other Error':
      outputColor = armColors.otherError.color;
      break;
    case 'Unknown Error':
      outputColor = armColors.unknownError.color;
      break;
    default:
      break;
  }
  return outputColor;
};

const pieChartOpts = {
  chart: {
    type: 'pie',
    animation: false
  },
  title: {
    text: 'Armature Health'
  },
  tooltip: {
    pointFormat: '{series.name}: <b>{point.y}</b>'
  },
  plotOptions: {
    pie: {
      cursor: 'pointer',
      dataLabels: {
        enabled: true,
        format: '{point.percentage:.1f} %',
        distance: -50,
        filter: {
          property: 'percentage',
          operator: '>',
          value: 5
        }
      }
    }
  },
  series: [],
  credits: false,
};

const formatData = (data, decodeObj) => {
  const outputData = {
    pie: [],
    table: []
  };

  data.forEach((item) => {
    if (item.armErrors && item.armErrors.length > 0) {
      item.armErrors.forEach((armError, errIndex) => {
        if (armError.name !== 'Healthy') {
          const errDescription = decodeObj.find(a => a.code === armError.code);
          outputData.table.push({
            LCUName: item.lcuName,
            armature: errIndex + 1,
            error: armError.name,
            description: errDescription ? errDescription.description : 'Unknown',
            timestamp: item.lastCollection
          });
        }

        const index = outputData.pie.findIndex(a => a.name === armError.name);
        if (index === -1) {
          outputData.pie.push({
            name: armError.name,
            color: pieChartColorPicker(armError.name),
            y: 1
          });
        } else {
          outputData.pie[index].y++;
        }
      });
    }
  });

  return outputData;
};

export default {
  name: 'ArmatureErrors',
  props: {
    gcu: {
      type: String
    }
  },
  data() {
    return {
      pieChartOpts,
      perPage: 10,
      currentPage: 1,
      tableFields: {
        LCUName: { label: 'Tracker Name' },
        armature: { label: 'Armature' },
        error: { label: 'Error' },
        description: { label: 'Description' },
        timestamp: { label: 'Timestamp' }
      }
    };
  },
  computed: {
    totalRows() {
      return this.tableData.length;
    },
    tableData() {
      const status = this.$store.getters['savanna/trackers/getTrackerStatus'](this.gcu);
      if (status && status.length > 0) {
        const decodeObj = this.$store.state.savanna.trackers.armatureStatusCodes;
        const formattedData = formatData(status, decodeObj);
        pieChartOpts.series = [{
          name: 'Armatures',
          data: formattedData.pie,
          animation: 0
        }];
        return formattedData.table;
      }
      pieChartOpts.series = [];
      return [];
    }
  }
};
</script>

<style>
#armErrorTable {
  width:100%;
  background-color:#FFF;
  margin-bottom: 0;
}
</style>
